export const count = {
    state: {
        inboxCount: 0,
        notificationCount: 0,
        memberRequestCount: 0,
        requestUpdateCount: 0,
        headerLogo: localStorage.getItem('headerLogo') || '',
    },
    getters: {
        inboxCount: state => state.inboxCount,
        notificationCount: state => state.notificationCount,
        memberRequestCount: state => state.memberRequestCount,
        requestUpdateCount: state => state.requestUpdateCount,
        headerLogo: state => state.headerLogo,
    },
    mutations: {
        setInboxCount(state, inboxCount) {
            state.inboxCount = inboxCount;
        },
        setNotificationCount(state, notificationCount) {
            state.notificationCount = notificationCount;
        },
        setMemberRequestCount(state, memberRequestCount) {
            state.memberRequestCount = memberRequestCount;
        },
        setRequestUpdateCount(state, requestUpdateCount) {
            state.requestUpdateCount = requestUpdateCount;
        },
        setHeaderLogo(state, headerLogo) {
            localStorage.setItem('headerLogo', headerLogo);
            state.headerLogo = headerLogo;
        }
    },
} 